import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from '../../../../common';
import RoleForm from './RoleForm.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { useGetRoleQuery } from '../../../../../redux/services/roles';
import { useGetPermissionsQuery } from '../../../../../redux/services/permissions';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import { AppBarCMS } from '../../../../basic';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Form from '../../../../antd/form/Form/Form';
import { isUndefined } from 'lodash';
const RolesDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Detail role') + ' - FRI CMS';
  }, []); // Runs on mount

  const {
    data: roleDetail,
    isLoading: isLoadingRole,
    isSuccess: isRoleDetailSuccess,
  } = useGetRoleQuery(id, {
    skip: isUndefined(id),
  });
  const { data: permissions, isLoading: isLoadingPermissions } =
    useGetPermissionsQuery();

  const [filteredPermissions, setFilteredPermissions] = useState(
    roleDetail?.permissions || [],
  );
  const [filteredUsers, setFilteredUsers] = useState(() => {
    if (roleDetail?.persons?.length) return roleDetail.persons;
    if (roleDetail?.external_users?.length) return roleDetail.external_users;
    return [];
  });
  const [roleName, setRoleName] = useState(roleDetail?.name || '');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [changesMade, setChangesMade] = useState(false);
  const initialPermissionsCount = useRef(0);
  const initialUsersCount = useRef(0);
  const initialName = useRef('');

  const initials = {
    id: undefined,
    name: undefined,
    permissions: undefined,
    ...roleDetail,
  };

  useEffect(() => {
    if (!isUndefined(roleDetail)) {
      setFilteredPermissions(roleDetail.permissions);
      setFilteredUsers(
        roleDetail.persons.length > 0
          ? roleDetail.persons
          : roleDetail.external_users,
      );
      setRoleName(roleDetail.name);
      if (
        isRoleDetailSuccess &&
        initialPermissionsCount.current === 0 &&
        initialUsersCount.current === 0 &&
        initialName.current === ''
      ) {
        initialPermissionsCount.current = roleDetail.permissions.length;
        initialUsersCount.current = roleDetail.persons.length;
        initialName.current = roleDetail.name;
      }
    }
  }, [roleDetail, isRoleDetailSuccess]);

  if (isLoadingRole || isLoadingPermissions) {
    return <Spinner />;
  }

  return (
    <>
      <AppBarCMS
        title={t('Detail role')}
        backUrl={routes.cmsRoles}
        backUrlTooltip={t('Role')}
        permissionsBasic="roles"
      />
      <div style={{ margin: '10px' }}>
        <Form initialValues={initials}>
          <RoleForm
            chosenPermissions={filteredPermissions}
            permissions={permissions || []}
            users={filteredUsers}
            changesMade={changesMade}
          />
        </Form>
      </div>
    </>
  );
};

export default RolesDetail;
